import {HttpClient} from '@angular/common/http';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {RtPlatformService} from 'rt-platform';
import {Subscription} from 'rxjs';
import {SPRITE_VERSION} from './sprite-version';

@Component({
    selector: 'rt-svg-sprite',
    templateUrl: './rt-svg-sprite.component.html',
    styleUrls: ['./rt-svg-sprite.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RtSvgSpriteComponent implements OnInit, OnDestroy {
  icons: SafeHtml = '';

  subscription = new Subscription();

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private platform: RtPlatformService,
  ) {
  }

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.subscription.add(
        this.http.get(`../shared/src/assets/symbol/sprites.svg?v=${SPRITE_VERSION}`, {responseType: 'text'})
          .subscribe(res => {
            this.icons = this.sanitizer.bypassSecurityTrustHtml(res);
            this.cdr.markForCheck();
          }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
